import { Fragment, useEffect } from 'react';

import Button from 'components/buttons/button';
const HandleRegistrationLimitExceeded = ({ handleClose }) => {
  
  useEffect(() => {
    window.posthog?.capture('View rate limit warning');
  }, []);
    
  return (
    <Fragment>
      <div className="error-message">
        <h5 className="title">Too many requests for this workplace</h5>
        <hr />
        <p>
            Cannot create another account at this time, please try again in a few minutes.
        </p>
        <hr />
      </div>
      <div className="error-button-group">
        <Button
          className="button button-cancel"
          type="button"
          text="Cancel"
          onClick={ handleClose }
        />
      </div>
    </Fragment>
  );
};

export default HandleRegistrationLimitExceeded;
